import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Layout from './Layout';
import './SubscriptionPricing.css';
import { useUserContext } from '../UserContext';
import { PLAN_CONFIG } from '../planConfig';

const PAID_PLANS = ['basic', 'pro', 'research'];

function SubscriptionPricing() {
  const navigate = useNavigate();
  const { isLoggedIn } = useUserContext();

  const handleSubscriptionClick = (planKey) => {
    if (isLoggedIn) {
      navigate(`/subscription?plan=${planKey}`);
    } else {
      navigate('/login');
    }
  };

  return (
    <Layout>
      <div className="subscription-pricing-container">
        <h1>Services Pricing</h1>
        <p>
          Explore our services — from our powerful dashboard with live and archive bids, results of bids and direct orders from GeM, results of tenders of other Non-GeM Govt. portals, bid studio, procurement reports to professional GeM training. Pick what fits your goals.
        </p>

        {/* -------- Annual Plans -------- */}
        <h2 className="section-heading">Annual Subscription Plans</h2>
        <p>
          All plans include full access to the <strong>Dashboard</strong>, TenderMaker AI bids,
          and procurement reports — with different usage limits.
        </p>

        <div className="pricing-cards">
          {PAID_PLANS.map((key) => {
            const cfg = PLAN_CONFIG[key];
            return (
              <div
                key={key}
                className={`pricing-card${key === 'pro' ? ' popular' : ''}`}
                onClick={() => handleSubscriptionClick(key)}
              >
                {key === 'pro' && <span className="popular-badge">POPULAR</span>}
                <h3>{cfg.label} Plan</h3>
                <h4>{'\u20B9'}{cfg.priceInr.toLocaleString('en-IN')} / year</h4>
                <ul style={{ textAlign: 'left', fontSize: 14, lineHeight: 2, paddingLeft: 18 }}>
                  <li>{cfg.limits.searches.toLocaleString()} tender discovery credits / month</li>
                  <li>{cfg.limits.results.toLocaleString()} results analysis credits / month</li>
                  <li>{cfg.limits.tmBids} bid analyses / month</li>
                  <li>{cfg.limits.reportRows.toLocaleString()} report rows / month</li>
                  <li>365 days validity</li>
                </ul>
                <button>Subscribe Now</button>
              </div>
            );
          })}

          <div className="pricing-card enterprise-card">
            <h3>Enterprise Plan</h3>
            <h4>Custom Pricing</h4>
            <p>Custom limits as per enterprise requirements.</p>
            <ul style={{ textAlign: 'left', fontSize: 14, lineHeight: 2, paddingLeft: 18 }}>
              <li>Custom monthly limits based on enterprise requirements</li>
              <li>Flexible scope</li>
              <li>Priority onboarding and support</li>
            </ul>
            <Link to="/contact-us">
              <button>Contact Sales</button>
            </Link>
          </div>
        </div>

        <p style={{ fontSize: 13, color: '#666', marginTop: 8 }}>
          New users get a <strong>3-day free trial</strong> on sign-up. Need more quota? Purchase add-ons from your dashboard.
        </p>

        {/* -------- GeM Training (unchanged) -------- */}
        <h2 className="section-heading">GeM Training Services</h2>
        <p>
          Live online training to help you master GeM — with real examples, checklists, and Q&amp;A.
          Choose a format that suits you.
        </p>

        <div className="pricing-cards">
          <div className="pricing-card">
            <h3>Personal 1:1 Online Training</h3>
            <p>3 Days (1 hr/day + Q&amp;A)</p>
            <h4>{'\u20B9'}11,999</h4>
            <a href="https://pages.razorpay.com/Personalcoach" target="_blank" rel="noreferrer">
              <button>Pay Now</button>
            </a>
          </div>

          <div className="pricing-card">
            <h3>Corporate / Team Training</h3>
            <p>3 Days (1 hr/day + Q&amp;A)</p>
            <h4>{'\u20B9'}27,999</h4>
            <a href="https://pages.razorpay.com/corporatetrainingbatches" target="_blank" rel="noreferrer">
              <button>Pay Now</button>
            </a>
          </div>

          <div className="pricing-card">
            <h3>Upcoming Open Batch</h3>
            <p>Fixed schedule · Core GeM topics</p>
            <h4>{'\u20B9'}7,999</h4>
            <a href="https://rzp.io/rzp/onlinecoursegem" target="_blank" rel="noreferrer">
              <button>Enroll Now</button>
            </a>
          </div>
        </div>

        {/* -------- Additional Services (unchanged) -------- */}
        <h2 className="section-heading">Additional Services</h2>
        <p>Quick services for specific requirements.</p>

        <div className="pricing-cards">
          <div className="pricing-card">
            <h3>GeM Account Creation</h3>
            <p>Complete setup & verification for your GeM seller account.</p>
            <a href="https://rzp.io/rzp/GemAccountCreation" target="_blank" rel="noreferrer">
              <button>Pay Now</button>
            </a>
          </div>

          <div className="pricing-card">
            <h3>Listing on GeM</h3>
            <p>Upload & approval support for products/services on GeM.</p>
            <a href="https://rzp.io/rzp/ListingsOnGeM" target="_blank" rel="noreferrer">
              <button>Pay Now</button>
            </a>
          </div>

          <div className="pricing-card">
            <h3>Bid Participation on GeM</h3>
            <p>End-to-end assistance for a specific bids on GeM</p>
            <a href="https://rzp.io/rzp/BidParticipation" target="_blank" rel="noreferrer">
              <button>Pay Now</button>
            </a>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default SubscriptionPricing;
